import { Inject, Injectable } from '@angular/core';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, SilentRequest } from '@azure/msal-browser';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MsAuthService {
  private _loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    this.isLoggedIn()
  );
  public loggedIn$: Observable<boolean> = this._loggedIn.asObservable();

  private _silentToken: BehaviorSubject<string | null> = new BehaviorSubject<
    string | null
  >(null);
  public silentToken$: Observable<string | null> =
    this._silentToken.asObservable();

  private _resolveToken: Subject<string | null> = new Subject<
    string | null
  >();
  public resolveToken$: Observable<string | null> =
    this._resolveToken.asObservable();

  private _tokenTimer: any; // skipcq
  private _accessToken: AuthenticationResult | undefined;

  constructor(
    private _msalAuthService: MsalService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
  ) {
    this._msalAuthService.handleRedirectObservable().subscribe({
      next: (_) => {
        if (this.isLoggedIn()) {
          this.fetchAccessToken();
        } else {
          this._silentToken.next(null);
        }
      },
      error: (err) => {
        // TODO: Handle errors
        console.error(err);
      }
    });
  }

  fetchAccessToken(refrsh?: boolean){
    if (this.isLoggedIn()) {
      this._msalAuthService
        .acquireTokenSilent({
          ...this.msalGuardConfig.authRequest,
          account: this._msalAuthService.instance.getAllAccounts()[0],
          forceRefresh: refrsh,
        } as SilentRequest)
        .subscribe({
          next: (result: AuthenticationResult) => {
            this.setAuthToken(result);
          },
        });
    }
  }


  isLoggedIn(): boolean {
    return (
      !!this._msalAuthService.instance &&
      this._msalAuthService.instance.getAllAccounts().length > 0
    );
  }

  private setAuthToken(result: AuthenticationResult) {
    if (result && result.accessToken) {
      this._accessToken = result;
      this._silentToken.next(result.accessToken);
      this._resolveToken.next(result.accessToken);
      this.tokenUpdater();
    }
  }

  private tokenUpdater(): void {
    if (this._tokenTimer) {
      return;
    } else {
      this._tokenTimer = setTimeout(() => {
        this._tokenTimer = undefined;
        let expireDate = new Date((this._accessToken?.expiresOn as Date).getTime() - (1000*120));
        if (this._accessToken?.expiresOn && (new Date() > expireDate)) {
          this._accessToken = undefined;
          this.fetchAccessToken();
        } else {
          this.tokenUpdater();
        }
      }, 30000);
    }
  }

  public get accessToken(): AuthenticationResult | undefined{
    return this._accessToken;
  }

  public hasToken(): boolean {
    return this.isLoggedIn() && this._accessToken != undefined;
  }
}
